import { QuestionCheckboxGroupField } from 'forms/previsit-questions/QuestionCheckboxGroupField';
import { QuestionMultiSelectField } from 'forms/previsit-questions/QuestionMultiSelectField';
import { QuestionRadioGroupField } from 'forms/previsit-questions/QuestionRadioGroupField';
import { QuestionSelectField } from 'forms/previsit-questions/QuestionSelectField';
import { QuestionTextField } from 'forms/previsit-questions/QuestionTextField';
import { assertNever } from '@tock/shared/utils/typeUtils';
import { core } from '@tock/coretypes';
import { getOptionsFromQuestion } from './questionOptions';
import { getQuestionFieldName } from '@tock/shared/utils/questionUtils';

interface Props {
  questions: core.TicketTypeQuestion[];
}

export const PreVisitQuestionsFieldset = ({ questions }: Props) => {
  return (
    <>
      {questions.map((question) => {
        const options = getOptionsFromQuestion(question);
        switch (question.type) {
          case 'TEXTINPUT':
            return <QuestionTextField question={question} key={question.id} />;
          case 'TEXTAREA':
            return <QuestionTextField question={question} multiline key={question.id} />;
          case 'RADIO_BUTTON':
            if (options.length >= 7) {
              return (
                <QuestionSelectField
                  question={question}
                  name={getQuestionFieldName(question)}
                  key={question.id}
                />
              );
            } else {
              return (
                <QuestionRadioGroupField
                  question={question}
                  name={getQuestionFieldName(question)}
                  key={question.id}
                />
              );
            }
          case 'CHECKBOXES':
            if (options.length >= 7) {
              return (
                <QuestionMultiSelectField
                  question={question}
                  name={getQuestionFieldName(question)}
                  key={question.id}
                />
              );
            } else {
              return (
                <QuestionCheckboxGroupField
                  question={question}
                  name={getQuestionFieldName(question)}
                  key={question.id}
                />
              );
            }
          default:
            assertNever(question.type);
        }
      })}
    </>
  );
};
